import React from 'react'
import { confirmationEmailOpDivPage } from './confirmationEmailOpDivPage'
import { ConfirmationEmail } from '../components/ConfirmationEmail'
import { PrintFOIA } from '../components/PrintFOIA'
import { Submit } from '../components/Submit'

export const reviewOpDivPage = complaintInspect => {
  const confirmEmailPage = confirmationEmailOpDivPage()
  const ceProps = {
    message:
      'Enter your email address to receive a complaint submission confirmation.'
  }
  const confirmEmail = () => <ConfirmationEmail {...ceProps} />
  const page = {
    id: 'review_page',
    fields: [
      {
        type: 'content',
        content: PrintFOIA
      },
      {
        type: 'content',
        content: complaintInspect
      },
      {
        type: 'content',
        content: confirmEmail
      }
    ],
    validation: confirmEmailPage.validation
  }

  page.fields.push(...confirmEmailPage.fields)
  page.fields.push({
    type: 'content',
    content: Submit
  })

  return page
}
